export const search: {
	SEARCH_FILTER_REQUEST: "SEARCH_FILTER_REQUEST";
	SEARCH_FILTER_RESPONSE: "SEARCH_FILTER_RESPONSE";
	PAGINATE_SEARCH_RESULTS: "PAGINATE_SEARCH_RESULTS";
	UPDATE_PAGINATION: "UPDATE_PAGINATION";
	PACKAGING_SEARCH_RESPONSE: "PACKAGING_SEARCH_RESPONSE";
	UPDATE_PACKAGING_PAGINATION: "UPDATE_PACKAGING_PAGINATION";
	SET_SEARCH_FILTER: "SET_SEARCH_FILTER";
	SET_SEARCH_TERM: "SET_SEARCH_TERM";
	SET_SEARCH_LOADING: "SET_SEARCH_LOADING";
	SET_PACKAGE_SEARCH_TERM: "SET_PACKAGE_SEARCH_TERM";
	SET_PACKAGE_SEARCH_LOADING: "SET_PACKAGE_SEARCH_LOADING";
	PORTFOLIO_PRODUCTS_SEARCH_RESPONSE: "PORTFOLIO_PRODUCTS_SEARCH_RESPONSE";
} = {
	SEARCH_FILTER_REQUEST: "SEARCH_FILTER_REQUEST",
	SEARCH_FILTER_RESPONSE: "SEARCH_FILTER_RESPONSE",
	PAGINATE_SEARCH_RESULTS: "PAGINATE_SEARCH_RESULTS",
	UPDATE_PAGINATION: "UPDATE_PAGINATION",
	PACKAGING_SEARCH_RESPONSE: "PACKAGING_SEARCH_RESPONSE",
	UPDATE_PACKAGING_PAGINATION: "UPDATE_PACKAGING_PAGINATION",
	SET_SEARCH_FILTER: "SET_SEARCH_FILTER",
	SET_SEARCH_TERM: "SET_SEARCH_TERM",
	SET_SEARCH_LOADING: "SET_SEARCH_LOADING",
	SET_PACKAGE_SEARCH_TERM: "SET_PACKAGE_SEARCH_TERM",
	SET_PACKAGE_SEARCH_LOADING: "SET_PACKAGE_SEARCH_LOADING",
	PORTFOLIO_PRODUCTS_SEARCH_RESPONSE: "PORTFOLIO_PRODUCTS_SEARCH_RESPONSE"
};

export const user: {
	LOGIN_REQUEST: "LOGIN_REQUEST";
	LOGIN_RESPONSE: "LOGIN_RESPONSE";
	LOGOUT_REQUEST: "LOGOUT_REQUEST";
	PROFILE_RESPONSE: "PROFILE_RESPONSE";
	USER_PREFERENCE_RESPONSE: "USER_PREFERENCE_RESPONSE";
	GET_ALL_COMPANY_USERS: "GET_ALL_COMPANY_USERS";
	SELECT_BRAND: "SELECT_BRAND";
	SET_VIEW_MODE: "SET_VIEW_MODE";
	GET_USER_CREDITS: "GET_USER_CREDITS";
	GET_ACCESS_PERMISSIONS: "GET_ACCESS_PERMISSIONS";
} = {
	LOGIN_REQUEST: "LOGIN_REQUEST",
	LOGIN_RESPONSE: "LOGIN_RESPONSE",
	LOGOUT_REQUEST: "LOGOUT_REQUEST",
	PROFILE_RESPONSE: "PROFILE_RESPONSE",
	USER_PREFERENCE_RESPONSE: "USER_PREFERENCE_RESPONSE",
	GET_ALL_COMPANY_USERS: "GET_ALL_COMPANY_USERS",
	SELECT_BRAND: "SELECT_BRAND",
	SET_VIEW_MODE: "SET_VIEW_MODE",
	GET_USER_CREDITS: "GET_USER_CREDITS",
	GET_ACCESS_PERMISSIONS: "GET_ACCESS_PERMISSIONS"
};

export const route = {
	CHANGE_ROUTE: "CHANGE_ROUTE"
};

export const admin: {
	PENDING_USER_REQUEST: "PENDING_USER_REQUEST";
	PENDING_USER_RESPONSE: "PENDING_USER_RESPONSE";
	ADMIN_PRODUCTS_RESPONSE: "ADMIN_PRODUCTS_RESPONSE";
	SELECT_PRODUCT: "SELECT_PRODUCT";
	PAGINATE_ADMIN_PRODUCT: "PAGINATE_ADMIN_PRODUCT";
	ADMIN_REPORT_REQUESTS_RESPONSE: "ADMIN_REPORT_REQUESTS_RESPONSE";
	PAGINATE_ADMIN_REPORT_REQUEST: "PAGINATE_ADMIN_REPORT_REQUEST";
	ADMIN_REPORTS_RESPONSE: "ADMIN_REPORTS_RESPONSE";
	PAGINATE_ADMIN_REPORTS: "PAGINATE_ADMIN_REPORTS";
	EMAIL_SCHEDULE_RESPONSE: "EMAIL_SCHEDULE_RESPONSE";
	ALL_USER_RESPONSE: "ALL_USER_RESPONSE";
	PRODUCT_STATISTICS_RESPONSE: "PRODUCT_STATISTICS_RESPONSE";
} = {
	PENDING_USER_REQUEST: "PENDING_USER_REQUEST",
	PENDING_USER_RESPONSE: "PENDING_USER_RESPONSE",
	ADMIN_PRODUCTS_RESPONSE: "ADMIN_PRODUCTS_RESPONSE",
	SELECT_PRODUCT: "SELECT_PRODUCT",
	PAGINATE_ADMIN_PRODUCT: "PAGINATE_ADMIN_PRODUCT",
	ADMIN_REPORT_REQUESTS_RESPONSE: "ADMIN_REPORT_REQUESTS_RESPONSE",
	PAGINATE_ADMIN_REPORT_REQUEST: "PAGINATE_ADMIN_REPORT_REQUEST",
	ADMIN_REPORTS_RESPONSE: "ADMIN_REPORTS_RESPONSE",
	PAGINATE_ADMIN_REPORTS: "PAGINATE_ADMIN_REPORTS",
	EMAIL_SCHEDULE_RESPONSE: "EMAIL_SCHEDULE_RESPONSE",
	ALL_USER_RESPONSE: "ALL_USER_RESPONSE",
	PRODUCT_STATISTICS_RESPONSE: "PRODUCT_STATISTICS_RESPONSE"
};

export const preference: {
	PREFERENCE_REQUEST: "PREFERENCE_REQUEST";
	PREFERENCE_RESPONSE: "PREFERENCE_RESPONSE";
} = {
	PREFERENCE_REQUEST: "PREFERENCE_REQUEST",
	PREFERENCE_RESPONSE: "PREFERENCE_RESPONSE"
};

export const ingredients: {
	INGREDIENTS_RESPONSE: "INGREDIENTS_REQUEST";
	INGREDIENTS_SEARCH_RESPONSE: "INGREDIENT_SEARCH_RESPONSE";
	SET_INGREDIENT_PAGINATION: "SET_INGREDIENT_PAGINATION";
	PAGINATE_INGREDIENTS: "PAGINATE_INGREDIENTS";
	GET_STARRED_INGREDIENTS_RESPONSE: "GET_STARRED_INGREDIENTS_RESPONSE";
	STARRED_INGREDIENTS_RESPONSE: "STARRED_INGREDIENTS_RESPONSE";
	GET_INGREDIENT_DETAIL_RESPONSE: "GET_INGREDIENT_DETAIL_RESPONSE";
	GET_INGREDIENT_PERSONA_RESPONSE: "GET_INGREDIENT_PERSONA_RESPONSE";
	GET_SIMILIAR_INGREDIENTS_RESPONSE: "GET_SIMILIAR_INGREDIENTS_RESPONSE";
	GET_INGREDIENT_STATUS_RESPONSE: "GET_INGREDIENT_STATUS_RESPONSE";
	GET_RECENTLY_VIEWED_INGREDIENT_RESPONSE: "GET_RECENTLY_VIEWED_INGREDIENT_RESPONSE";
	GET_INGREDIENT_USAGE: "GET_INGREDIENT_USAGE";
	GET_BUYERS_PREVIEW: "GET_BUYERS_PREVIEW";
	SET_SEARCH_TERM: "SET_SEARCH_TERM";
} = {
	INGREDIENTS_RESPONSE: "INGREDIENTS_REQUEST",
	SET_INGREDIENT_PAGINATION: "SET_INGREDIENT_PAGINATION",
	PAGINATE_INGREDIENTS: "PAGINATE_INGREDIENTS",
	GET_STARRED_INGREDIENTS_RESPONSE: "GET_STARRED_INGREDIENTS_RESPONSE",
	STARRED_INGREDIENTS_RESPONSE: "STARRED_INGREDIENTS_RESPONSE",
	GET_INGREDIENT_DETAIL_RESPONSE: "GET_INGREDIENT_DETAIL_RESPONSE",
	GET_INGREDIENT_PERSONA_RESPONSE: "GET_INGREDIENT_PERSONA_RESPONSE",
	GET_SIMILIAR_INGREDIENTS_RESPONSE: "GET_SIMILIAR_INGREDIENTS_RESPONSE",
	GET_INGREDIENT_STATUS_RESPONSE: "GET_INGREDIENT_STATUS_RESPONSE",
	GET_RECENTLY_VIEWED_INGREDIENT_RESPONSE: "GET_RECENTLY_VIEWED_INGREDIENT_RESPONSE",
	INGREDIENTS_SEARCH_RESPONSE: "INGREDIENT_SEARCH_RESPONSE",
	GET_INGREDIENT_USAGE: "GET_INGREDIENT_USAGE",
	GET_BUYERS_PREVIEW: "GET_BUYERS_PREVIEW",
	SET_SEARCH_TERM: "SET_SEARCH_TERM"
};

export const company: {
	GET_COMPANY_RESPONSE: "GET_COMPANY_RESPONSE";
} = {
	GET_COMPANY_RESPONSE: "GET_COMPANY_RESPONSE"
};

export const integration: {
	GET_INTEGRATIONS_RESPONSE: "GET_INTEGRATIONS_RESPONSE";
	GET_ALL_REQUESTS_RESPONSE: "GET_ALL_REQUESTS_RESPONSE";
} = {
	GET_INTEGRATIONS_RESPONSE: "GET_INTEGRATIONS_RESPONSE",
	GET_ALL_REQUESTS_RESPONSE: "GET_ALL_REQUESTS_RESPONSE"
};

export const dashboard: {
	GET_DASHBOARD_OVERVIEW_RESPONSE: "GET_DASHBOARD_OVERVIEW_RESPONSE";
	GET_DASHBOARD_PRODUCT_ANALYTICS_RESPONSE: "GET_DASHBOARD_PRODUCT_ANALYTICS_RESPONSE";
	GET_DASHBOARD_ACTIVE_PRODUCT_RESPONSE: "GET_DASHBOARD_ACTIVE_PRODUCT_RESPONSE";
	GET_DASHBOARD_CONCEPT_PRODUCT_RESPONSE: "GET_DASHBOARD_CONCEPT_PRODUCT_RESPONSE";
} = {
	GET_DASHBOARD_OVERVIEW_RESPONSE: "GET_DASHBOARD_OVERVIEW_RESPONSE",
	GET_DASHBOARD_PRODUCT_ANALYTICS_RESPONSE: "GET_DASHBOARD_PRODUCT_ANALYTICS_RESPONSE",
	GET_DASHBOARD_ACTIVE_PRODUCT_RESPONSE: "GET_DASHBOARD_ACTIVE_PRODUCT_RESPONSE",
	GET_DASHBOARD_CONCEPT_PRODUCT_RESPONSE: "GET_DASHBOARD_CONCEPT_PRODUCT_RESPONSE"
};

export const product: {
	GET_ACTIVE_PRODUCT_RESPONSE: "GET_ACTIVE_PRODUCT_RESPONSE";
	GET_CONCEPT_PRODUCT_RESPONSE: "GET_CONCEPT_PRODUCT_RESPONSE";
	GET_PRODUCT_DETAIL_RESPONSE: "GET_PRODUCT_DETAIL_RESPONSE";
	GET_PRODUCT_PERSONA_RESPONSE: "GET_PRODUCT_PERSONA_RESPONSE";
	PAGINATE_CONCEPT_PRODUCT: "PAGINATE_CONCEPT_PRODUCT";
	PAGINATE_ACTIVE_PRODUCT: "PAGINATE_ACTIVE_PRODUCT";
	GET_PRODUCT_VERSIONS_RESPONSE: "GET_PRODUCT_VERSIONS_RESPONSE";
	GET_PRODUCT_PACKAGES_RESPONSE: "GET_PRODUCT_PACKAGES_RESPONSE";
	GET_RECENTLY_VIEWED_PRODUCT_RESPONSE: "GET_RECENTLY_VIEWED_PRODUCT_RESPONSE";
	SET_PRODUCT_FILTERS: "SET_PRODUCT_FILTERS";
	CLEAR_PRODUCT_FILTERS: "CLEAR_PRODUCT_FILTERS";
} = {
	GET_ACTIVE_PRODUCT_RESPONSE: "GET_ACTIVE_PRODUCT_RESPONSE",
	GET_CONCEPT_PRODUCT_RESPONSE: "GET_CONCEPT_PRODUCT_RESPONSE",
	GET_PRODUCT_DETAIL_RESPONSE: "GET_PRODUCT_DETAIL_RESPONSE",
	PAGINATE_CONCEPT_PRODUCT: "PAGINATE_CONCEPT_PRODUCT",
	PAGINATE_ACTIVE_PRODUCT: "PAGINATE_ACTIVE_PRODUCT",
	GET_PRODUCT_PERSONA_RESPONSE: "GET_PRODUCT_PERSONA_RESPONSE",
	GET_PRODUCT_VERSIONS_RESPONSE: "GET_PRODUCT_VERSIONS_RESPONSE",
	GET_PRODUCT_PACKAGES_RESPONSE: "GET_PRODUCT_PACKAGES_RESPONSE",
	GET_RECENTLY_VIEWED_PRODUCT_RESPONSE: "GET_RECENTLY_VIEWED_PRODUCT_RESPONSE",
	SET_PRODUCT_FILTERS: "SET_PRODUCT_FILTERS",
	CLEAR_PRODUCT_FILTERS: "CLEAR_PRODUCT_FILTERS"
};

export const persona: {
	GET_ALL_PERSONAS_RESPONSE: "GET_ALL_PERSONAS_RESPONSE";
} = {
	GET_ALL_PERSONAS_RESPONSE: "GET_ALL_PERSONAS_RESPONSE"
};

export const notification: {
	GET_ALL_NOTIFICATIONS_RESPONSE: "GET_ALL_NOTIFICATIONS_RESPONSE";
} = {
	GET_ALL_NOTIFICATIONS_RESPONSE: "GET_ALL_NOTIFICATIONS_RESPONSE"
};

export const packaging: {
	GET_ALL_PACKAGES_RESPONSE: "GET_ALL_PACKAGES_RESPONSE";
	UPDATE_PAGINATION: "UPDATE_PAGINATION";
	SELECT_PACKAGE: "SELECT_PACKAGE";
} = {
	GET_ALL_PACKAGES_RESPONSE: "GET_ALL_PACKAGES_RESPONSE",
	UPDATE_PAGINATION: "UPDATE_PAGINATION",
	SELECT_PACKAGE: "SELECT_PACKAGE"
};

export const report: {
	GET_ALL_REPORTS_RESPONSE: "GET_ALL_REPORTS_RESPONSE";
	PAGINATE_REPORTS: "PAGINATE_REPORTS";
	GET_ALL_REPORT_REQUESTS_RESPONSE: "GET_ALL_REPORT_REQUESTS_RESPONSE";
	GET_WHITEPAPER_RESPONSE: "GET_WHITEPAPER_RESPONSE";
} = {
	GET_ALL_REPORTS_RESPONSE: "GET_ALL_REPORTS_RESPONSE",
	PAGINATE_REPORTS: "PAGINATE_REPORTS",
	GET_ALL_REPORT_REQUESTS_RESPONSE: "GET_ALL_REPORT_REQUESTS_RESPONSE",
	GET_WHITEPAPER_RESPONSE: "GET_WHITEPAPER_RESPONSE"
};

export const recommendations: {
	GET_ALL_RECOMMENDATIONS_RESPONSE: "GET_ALL_RECOMMENDATIONS_RESPONSE";
} = {
	GET_ALL_RECOMMENDATIONS_RESPONSE: "GET_ALL_RECOMMENDATIONS_RESPONSE"
};

export const analytics: {
	GET_REPORTS: "GET_REPORTS";
	GET_TIME_SAVED: "GET_TIME_SAVED";
	FILTER_TIME_SAVED: "FILTER_TIME_SAVED";
	GET_PRODUCT_CHANGES: "GET_PRODUCT_CHANGES";
	FILTER_PRODUCT_CHANGES: "FILTER_PRODUCT_CHANGES";
} = {
	GET_REPORTS: "GET_REPORTS",
	GET_TIME_SAVED: "GET_TIME_SAVED",
	FILTER_TIME_SAVED: "FILTER_TIME_SAVED",
	GET_PRODUCT_CHANGES: "GET_PRODUCT_CHANGES",
	FILTER_PRODUCT_CHANGES: "FILTER_PRODUCT_CHANGES"
};

export const product_types: {
	GET_ALL_PRODUCT_TYPES: "GET_ALL_PRODUCT_TYPES";
} = {
	GET_ALL_PRODUCT_TYPES: "GET_ALL_PRODUCT_TYPES"
};

export const billing: {
	GET_ALL_INVOICES: "GET_ALL_INVOICES";
	GET_COMPANY_INVOICES: "GET_USER_INVOICES";
	GET_INVOICE: "GET_INVOICE";
} = {
	GET_ALL_INVOICES: "GET_ALL_INVOICES",
	GET_COMPANY_INVOICES: "GET_USER_INVOICES",
	GET_INVOICE: "GET_INVOICE"
};

export const supplier: {
	GET_ALL_SUPPLIER_RESPONSE: "GET_ALL_SUPPLIER_RESPONSE";
	GET_SUPPLIER_INGREDIENT: "GET_SUPPLIER_INGREDIENT";
	PAGINATE_SUPPLIER_INGREDIENT: "PAGINATE_SUPPLIER_INGREDIENT";
} = {
	GET_ALL_SUPPLIER_RESPONSE: "GET_ALL_SUPPLIER_RESPONSE",
	GET_SUPPLIER_INGREDIENT: "GET_SUPPLIER_INGREDIENT",
	PAGINATE_SUPPLIER_INGREDIENT: "PAGINATE_SUPPLIER_INGREDIENT"
};

// Chat action constants
export const CHAT_CREATE_SESSION_REQUEST = "CHAT_CREATE_SESSION_REQUEST";
export const CHAT_CREATE_SESSION_SUCCESS = "CHAT_CREATE_SESSION_SUCCESS";
export const CHAT_CREATE_SESSION_FAILURE = "CHAT_CREATE_SESSION_FAILURE";

export const CHAT_SEND_MESSAGE_REQUEST = "CHAT_SEND_MESSAGE_REQUEST";
export const CHAT_SEND_MESSAGE_SUCCESS = "CHAT_SEND_MESSAGE_SUCCESS";
export const CHAT_SEND_MESSAGE_FAILURE = "CHAT_SEND_MESSAGE_FAILURE";

export const CHAT_LOAD_SESSION_REQUEST = "CHAT_LOAD_SESSION_REQUEST";
export const CHAT_LOAD_SESSION_SUCCESS = "CHAT_LOAD_SESSION_SUCCESS";
export const CHAT_LOAD_SESSION_FAILURE = "CHAT_LOAD_SESSION_FAILURE";

export const CHAT_LOAD_USER_SESSIONS_REQUEST = "CHAT_LOAD_USER_SESSIONS_REQUEST";
export const CHAT_LOAD_USER_SESSIONS_SUCCESS = "CHAT_LOAD_USER_SESSIONS_SUCCESS";
export const CHAT_LOAD_USER_SESSIONS_FAILURE = "CHAT_LOAD_USER_SESSIONS_FAILURE";

export const CHAT_SET_CURRENT_SESSION = "CHAT_SET_CURRENT_SESSION";
export const CHAT_CLEAR_MESSAGES = "CHAT_CLEAR_MESSAGES";
export const CHAT_SET_AI_TYPING = "CHAT_SET_AI_TYPING";
export const CHAT_RESET_STATE = "CHAT_RESET_STATE";

export const CHAT_ADD_OPTIMISTIC_MESSAGE = "CHAT_ADD_OPTIMISTIC_MESSAGE";
export const CHAT_UPDATE_MESSAGE_STATUS = "CHAT_UPDATE_MESSAGE_STATUS";
export const CHAT_REMOVE_OPTIMISTIC_MESSAGE = "CHAT_REMOVE_OPTIMISTIC_MESSAGE";

export const CHAT_DELETE_SESSION_REQUEST = "CHAT_DELETE_SESSION_REQUEST";
export const CHAT_DELETE_SESSION_SUCCESS = "CHAT_DELETE_SESSION_SUCCESS";
export const CHAT_DELETE_SESSION_FAILURE = "CHAT_DELETE_SESSION_FAILURE";

export const CHAT_SET_SELECTED_MODEL = "CHAT_SET_SELECTED_MODEL";
